import { opAlfabet } from './alfabetisch';

/**
 * Clubkiezer voor een super-admin (eigenaar 24-10-2026, variant D): hij logt
 * met zijn eigen account in en kiest een club, in plaats van in te loggen met
 * een gedeeld clubaccount. Hier staat wat de lijst laat zien; het venster zelf
 * is components/club-kiezer.
 */

/** Eén keuze, zoals auth hem levert (GET /Account/Impersonate/Clubs). */
export interface ClubKeuze {
  club: string;
  name: string;
  logo: string;
  /** club | league | tagging */
  kind: string;
  country: string;
}

export interface ClubKeuzeGroepen {
  recent: ClubKeuze[];
  clubs: ClubKeuze[];
  leagues: ClubKeuze[];
  tagging: ClubKeuze[];
}

/** Zoveel recent geopende clubs staan bovenaan. */
export const MAX_RECENT = 3;

/** Zoeken zonder op hoofdletters of accenten te letten ("liege" vindt "Liège"). */
export function zoekVorm(tekst: string | null | undefined): string {
  return (tekst ?? '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
}

/**
 * De lijst in groepen, elke groep op alfabet. Zolang er geen zoekterm is,
 * staan de recent geopende clubs er ook nog bovenaan; met een zoekterm staat
 * alles alleen in zijn eigen groep.
 */
export function groepeerKeuzes(keuzes: readonly ClubKeuze[], zoek: string, recent: readonly string[]): ClubKeuzeGroepen {
  const term = zoekVorm(zoek);
  const gevonden = term ? keuzes.filter((k) => zoekVorm(k.name).includes(term)) : [...keuzes];
  const opNaam = (lijst: ClubKeuze[]) => opAlfabet(lijst, (k) => k.name);
  return {
    recent: term
      ? []
      : recent
        .map((sid) => keuzes.find((k) => k.club === sid))
        .filter((k): k is ClubKeuze => !!k)
        .slice(0, MAX_RECENT),
    clubs: opNaam(gevonden.filter((k) => k.kind !== 'league' && k.kind !== 'tagging')),
    leagues: opNaam(gevonden.filter((k) => k.kind === 'league')),
    tagging: opNaam(gevonden.filter((k) => k.kind === 'tagging')),
  };
}

/** De eerste keuze in de volgorde van het scherm: Enter in het zoekveld opent die. */
export function eersteKeuze(groepen: ClubKeuzeGroepen): ClubKeuze | null {
  return groepen.recent[0] ?? groepen.clubs[0] ?? groepen.leagues[0] ?? groepen.tagging[0] ?? null;
}

/** De club vooraan in de recente lijst, zonder dubbele, hooguit {@link MAX_RECENT}. */
export function voegRecentToe(recent: readonly string[] | null | undefined, club: string): string[] {
  const lijst = Array.isArray(recent) ? recent.filter((s) => typeof s === 'string') : [];
  return [club, ...lijst.filter((s) => s !== club)].slice(0, MAX_RECENT);
}
